import { CMSLink } from '@/components/Link'
import { opsampButtonClasses } from '@/utilities/opsampDesign'
import { cn } from '@/utilities/ui'

interface CTAProps {
  cta: any
  className?: string
  ariaLabel?: string
  defaultAriaLabel?: string
  centerAlign?: boolean
  wrapperClassName?: string
  size?: 'sm' | 'md' | 'lg'
}

const CTA = ({
  cta,
  className,
  ariaLabel,
  defaultAriaLabel = 'Call to action',
  centerAlign = true,
  wrapperClassName,
  size = 'md',
}: CTAProps) => {
  if (!cta) return null

  // Prefer appearance from Payload (linkGroup -> link.appearance)
  const appearance = cta?.appearance as
    | 'default'
    | 'secondary'
    | 'outline'
    | 'ghost'
    | 'destructive'
    | undefined

  const sizeClasses = {
    sm: 'min-h-10 px-4 text-sm',
    md: 'min-h-[52px] px-[22px] text-base',
    lg: 'min-h-[52px] px-7 text-base',
  }

  const containerClasses = cn(
    'flex',
    centerAlign ? 'flex-1 justify-center mt-10' : 'justify-start',
    wrapperClassName,
  )

  const linkClasses = cn(
    opsampButtonClasses(appearance === 'outline' || appearance === 'secondary' ? 'secondary' : 'primary'),
    'z-10 cursor-pointer',
    sizeClasses[size],
    className,
  )

  return (
    <nav className={containerClasses} aria-label={ariaLabel || defaultAriaLabel}>
      <div className="relative w-fit inline-flex overflow-hidden group/link">
        <CMSLink {...cta} className={linkClasses} aria-label={cta?.label || defaultAriaLabel}>
          {cta?.label && <span>{cta.label}</span>}
        </CMSLink>
      </div>
    </nav>
  )
}

export default CTA
